<script setup>
import { DsButton } from '@dss360/design-system'
import DssNewHeader from '@/core/components/dss-new-header/dss-new-header.vue'
import DssSidebar from '@/core/components/dss-sidebar/dss-sidebar.vue'
import BradleySidePanel from '@/modules/new-bradley/components/bradley-side-panel.vue'
import { useProjectSetupStore } from '@/modules/sps/stores/sps.store.ts'
import DssBreadcrumb from '@/shared/components/dss-breadcrumb/dss-breadcrumb.vue'

defineOptions({
  name: 'WizardLayout',
})

const projectSetupStore = useProjectSetupStore()
</script>

<template>
  <div class="grid grid-rows-[auto_1fr] min-h-screen font-inter bg-white">
    <dss-new-header />
    <bradley-side-panel />

    <div class="grid grid-cols-[auto_1fr] min-w-0">
      <dss-sidebar />

      <div class="flex flex-col min-w-0">
        <dss-breadcrumb />

        <div
          id="home-layout-content"
          class="flex-1 flex flex-col gap-8 p-8 bg-dss-surface-10 min-w-0 relative overflow-y-auto pb-0"
        >
          <router-view />
        </div>

        <div class="sticky bottom-0 z-50 bg-white border-t border-t-dss-surface-200 flex flex-row justify-between px-8 py-6 w-full">
          <div id="left-panel">
            <ds-button
              class="cursor-pointer"
              :label="projectSetupStore.state.returnBtnLabel"
              outlined
              :icon="projectSetupStore.state.currentStep > 1 ? 'pi pi-chevron-left' : undefined"
              icon-pos="right"
              @click="projectSetupStore.previous()"
            />
          </div>
          <div
            id="right-panel"
            class="flex flex-row gap-3"
          >
            <ds-button
              v-if="!projectSetupStore.isReadOnly || projectSetupStore.state.currentStep === 1"
              class="cursor-pointer"
              :severity="projectSetupStore.state.mode === 'creation' || projectSetupStore.state.form.status === 'active' ? 'secondary' : 'primary'"
              :label="projectSetupStore.state.saveBtnLabel"
              :loading="projectSetupStore.state.saveLoading"
              @click="projectSetupStore.saveDraft()"
            />
            <ds-button
              v-if="projectSetupStore.state.currentStep === 3 && !projectSetupStore.isReadOnly"
              class="cursor-pointer"
              :label="projectSetupStore.state.previewLabel"
              outlined
              @click="projectSetupStore.setDrawer()"
            />
            <ds-button
              v-if="projectSetupStore.state.mode === 'creation'"
              class="cursor-pointer flex-row-reverse"
              :label="projectSetupStore.state.proceedBtnLabel"
              :icon="projectSetupStore.state.currentStep < 3 ? 'pi pi-chevron-right' : undefined"
              icon-pos="right"
              :loading="projectSetupStore.state.loading"
              @click="projectSetupStore.next()"
            />
            <ds-button
              v-else-if="!projectSetupStore.isReadOnly"
              class="cursor-pointer"
              :label="projectSetupStore.state.publishBtnLabel"
              :loading="projectSetupStore.state.loading"
              @click="projectSetupStore.publishEdition()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
